import React, { Component } from 'react';

class IconNewWindow extends Component {
    render() {
        return (
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>New window</title>
            <g id="icon-/-new-window" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
              <path d="M9,1.5 L3,1.5 C2.171,1.5 1.5,2.171 1.5,3 L1.5,21 C1.5,21.829 2.171,22.5 3,22.5 L21,22.5 C21.829,22.5 22.5,21.829 22.5,21 L22.5,14.5" id="Stroke-1" stroke="#ffffff" strokeWidth="2"/>
              <polyline id="Stroke-3" stroke="#ffffff" strokeWidth="2" points="15 1.5 22.5 1.5 22.5 8.5"/>
              <path d="M22.5,1.5 L12.25,11.75" id="Stroke-5" stroke="#ffffff" strokeWidth="2"/>
            </g>
          </svg>
        )
    }
}

export default IconNewWindow;